import { memo } from 'react';

interface TimelineSpacerProps {
  widthRem: number;
  height: number | string;
}

/**
 * Empty spacer element used to offset timeline cells during horizontal virtualization.
 * Fills the gap before/after the visible date window so rows maintain correct total width.
 */
export const TimelineSpacer = memo(({ widthRem, height }: TimelineSpacerProps) => {
  if (widthRem <= 0) return null;

  return (
    <div
      className="shrink-0"
      style={{
        width: `${widthRem}rem`,
        minWidth: `${widthRem}rem`,
        height,
      }}
    />
  );
});
